import { Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BaseController, IColumnSetting } from '@discoverer/core/services';
import { AppSettingsService, ITab2, TabSettingsService } from '@discoverer/core/services/dynamic-reports-services';
import { combineLatest } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';

export class DiscoTabContext {
    constructor(
        public currentTab: ITab2,
        public columnSettings: IColumnSetting[],
        public columnDictionary: { [key: string]: IColumnSetting }
    ) {
    }
}

@Component({
    selector: 'disco-tab',
    templateUrl: './disco-tab.component.html',
    styleUrls: ['./disco-tab.component.scss'],
    providers: [
        TabSettingsService
    ]
})
export class DiscoTabComponent extends BaseController implements OnInit {
    private _appId: string;
    private _tabId: string;
    private _initialized = false;

    @Input()
    set appId(val: string) {
        this._appId = val;
        this.initializeIfReady();
    }

    @Input()
    set tabId(val: string) {
        this._tabId = val;
        this.initializeIfReady();
    }

    @Output()
    context = new EventEmitter<DiscoTabContext>(true);

    @ContentChild(TemplateRef) template: TemplateRef<ElementRef>;

    constructor(
        private _appSettings: AppSettingsService,
        private _tabSettings: TabSettingsService
    ) {
        super();
    }

    public ngOnInit() {
        this.initializeIfReady();
    }

    private async initializeIfReady() {
        if (!this._appId || !this._tabId || this._initialized) {
            return;
        }

        this._initialized = true;

        try {
            await this._tabSettings.setCurrentTab(this._tabId, this._appId);
            const contextSubscription = combineLatest([
                this._tabSettings.oCurrentTab,
                this._tabSettings.oColumnSettings,
                this._tabSettings.oColumnDictionary
            ]).pipe(
                debounceTime(10),
                filter(([tab]) => tab?.app?.key === this._appId && tab?.key === this._tabId)
            ).subscribe(([tab, columns, dictionary]) => {
                this.context.emit(null);
                this.context.emit(new DiscoTabContext(tab, columns, dictionary));
            });

            this.subscriptions.push(contextSubscription);
        } catch (error) {
            console.error(`Failed to initialize disco-tab for app ${this._appId}, tab ${this._tabId}:`, error);
        }
    }
}